<script>
// this component is a router-link HOC
// It allows to seamlessy implement custom logic routing (slicing for example)
import { mergeData } from 'vue-functional-data-merge';

export default {
  functional: true,
  name: 'LauncherRouterLink',
  render (h, ctx) {
    const { props, children, data, parent } = ctx;
    const redirectToSlicedVersion = parent.$route.meta.isSliced;
    const { query = {}, params = {} } = parent.$route || {};
    const { debug, interopVersion } = query;
    const { stationId } = params;

    // For interop VR needs, we find the closest PanelContainer in order to retrieve its id
    // which is required for modal panel (we want them to be displayed on place)
    const { id: modalParentId } = (function findParentPanelContainer (vm) {
      if (!vm) return {};
      return vm.$options.name === 'PanelContainer' ? vm : findParentPanelContainer(vm.$parent);
    })(parent);

    const to = props.to ? {
      ...props.to,
      name: redirectToSlicedVersion ? `vr:${props.to.name}` : props.to.name,
      query: {
        debug,
        interopVersion,
        modalParentId,
        ...props.to.query,
      },
      params: {
        stationId,
        // ...params,
        ...props.to.params,
      },
    } : '';
    return h('router-link',
      mergeData(data, {
        props: {
          to,
        },
      })
      , children);
  },
};
</script>
